import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';

import { createReducer, on } from '@ordersnproducts/utils/create-reducer';

import ScheduleDatesActions from '../actions/schedule-dates.action';

export interface ScheduleDate {
  timestamp: number;
  forms: string[];
}

export interface State extends EntityState<ScheduleDate> {
  selectedScheduleDate: string | undefined;
}

export const adapter: EntityAdapter<ScheduleDate> = createEntityAdapter<ScheduleDate>({
  // selectId: () => `${payload.shipmentLocationId}`,
  selectId: (_scheduleDate) => _scheduleDate.timestamp,
  sortComparer: false,
});

const initialState: State = adapter.getInitialState({
  selectedScheduleDate: undefined,
});

export const formCounter = -1;

export const scheduleDatesReducer = createReducer(
  initialState,

  on(ScheduleDatesActions.addDate, (state, { timestamp }) => {
    return adapter.upsertOne(
      {
        timestamp: timestamp,
        forms: [],
      },
      state,
    );
  }),

  on(ScheduleDatesActions.resetScheduleDate, (state) => ({
    ...initialState,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return scheduleDatesReducer(state, action);
}
